// Dummy house data for the configurator
import FirstFloorFront1 from '../assets/interior/First Floor Front Bed/Scene 2-1.png';
import FirstFloorFront2 from '../assets/interior/First Floor Front Bed/Scene 3-1.png';
import FirstFloorFront3 from '../assets/interior/First Floor Front Bed/Scene 4-1.png';
import GroundFloorInterior1 from '../assets/interior/Ground floor interior/Document from M. Frasat(1).png';
import GroundFloorInterior2 from '../assets/interior/Ground floor interior/Document from M. Frasat(2).png';
import GroundFloorInterior3 from '../assets/interior/Ground floor interior/Document from M. Frasat(3).png';
import GroundFloorMasterBed1 from '../assets/interior/Ground floor Master Bed/Scene 1-1.png';
import GroundFloorMasterBed2 from '../assets/interior/Ground floor Master Bed/Scene 2-2.png';
import GroundFloorMasterBed3 from '../assets/interior/Ground floor Master Bed/Scene 3.png';
import stairs1 from '../assets/interior/stairs/FIrst floor & mazinine -2.jpg';
import stairs2 from '../assets/interior/stairs/Photo from M. Frasat(1).jpg';
import stairs3 from '../assets/interior/stairs/FIrst floor & mazinine.jpg';
import firstFloorFrontVideo from '../assets/animations/Interior Animations/First floor front Bed/First floor front bed-1.mp4';
import groundFloorInteriorVideo from '../assets/animations/Ground floor/Living-1.mp4';
import groundFloorMasterBedVideo from '../assets/animations/Interior Animations/Ground Floor Master Bed/Master Bed-1.mp4';
import stairsVideo from '../assets/animations/Stairs/Stairs-1.mp4';
import elevationOption1Video from '../assets/Elevetions/Option-1/1.mp4';
import elevationOption1Image1 from '../assets/Elevetions/Option-1/Images/01.jpg';
import elevationOption1Image2 from '../assets/Elevetions/Option-1/Images/03.jpg';
import elevationOption1Image3 from '../assets/Elevetions/Option-1/Images/05.jpg';
import elevationOption2Video from '../assets/Elevetions/Option-2/1.mp4';
import elevationOption2Image1 from '../assets/Elevetions/Option-2/Images/01.jpg';
import elevationOption2Image2 from '../assets/Elevetions/Option-2/Images/02.jpg';
import elevationOption2Image3 from '../assets/Elevetions/Option-2/Images/03.jpg';
// import elevationOption3Video from '../assets/Elevetions/Option-3/5 Marla-1.mp4';
import elevationOption3Image1 from '../assets/Elevetions/Option-3/Images/Day 1.png';
import elevationOption3Image2 from '../assets/Elevetions/Option-3/Images/Night1-1.jpeg';

export const popularBuild = {
  id: 'villa-840',
  name: 'Luxury Villa 840',
  type: 'Modern Villa',
  price: 1124800,
  currency: 'USD',
  image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&h=600&fit=crop',
  features: [
    '5 Bedrooms',
    '4.5 Bathrooms',
    '3,500 sq ft',
    'Swimming Pool',
    'Smart Home System',
    'Premium Finishes'
  ],
  description: 'A stunning modern villa with contemporary design and luxury amenities',
  stats: {
    bedrooms: 5,
    bathrooms: 4.5,
    sqft: 3500,
    year: 2025,
    energyRating: 'A+'
  },
  highlights: [
    'Ocean View',
    'Smart Home Integration',
    'Sustainable Design',
    'Premium Materials'
  ]
};

export const lastBuild = {
  id: 'villa-750',
  name: 'Classic Villa 750',
  type: 'Traditional Villa',
  date: 'Dec 31, 2025',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=400&h=300&fit=crop'
};

// House models for showcase section
export const houseModels = [
  {
    id: 'eco-villa-ix',
    name: 'Eco Villa iX',
    type: 'Luxury Estate',
    title: 'Eco Villa iX Luxury Estate',
    description: 'The all-electric estate setting standards for sustainability, technology, and luxury.',
    startingPrice: 751500,
    priceAsShown: 804500,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=800&fit=crop',
    backgroundType: 'white',
    note: null,
    productCategory: '5-marla-classic', // 5-marla-classic, 5-marla-modern, 10-marla-classic, 10-marla-modern
    mediaKey: 'eco-villa-ix'
  },
  {
    id: 'eco-villa-i4',
    name: 'Eco Villa i4',
    type: 'Modern Residence',
    title: 'Eco Villa i4 Modern Residence',
    description: 'Cutting-edge all-electric performance in a luxurious four-bedroom contemporary home.',
    startingPrice: 579000,
    priceAsShown: 616500,
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop',
    backgroundType: 'scenic', // white or scenic
    note: '• 2025 Eco Villa i4 Model and Pricing Shown',
    productCategory: '5-marla-modern',
    mediaKey: 'eco-villa-i4'
  },
  {
    id: 'villa-10m-classic-1',
    name: 'Classic Villa 10M',
    type: 'Classic Estate',
    title: '10 Marla Classic Villa',
    description: 'Traditional elegance meets modern comfort in this spacious classic design.',
    startingPrice: 950000,
    priceAsShown: 1020000,
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&h=800&fit=crop',
    backgroundType: 'white',
    note: null,
    productCategory: '10-marla-classic',
    mediaKey: 'villa-10m-classic-1'
  },
  {
    id: 'villa-10m-modern-1',
    name: 'Modern Villa 10M',
    type: 'Modern Estate',
    title: '10 Marla Modern Villa',
    description: 'Contemporary design with cutting-edge features and luxurious finishes.',
    startingPrice: 1100000,
    priceAsShown: 1180000,
    image: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1200&h=800&fit=crop',
    backgroundType: 'scenic',
    note: null,
    productCategory: '10-marla-modern',
    mediaKey: 'villa-10m-modern-1'
  },
  {
    id: 'villa-5m-classic-2',
    name: 'Classic Villa 5M',
    type: 'Classic Home',
    title: '5 Marla Classic Home',
    description: 'Charming classic design perfect for families seeking traditional elegance.',
    startingPrice: 650000,
    priceAsShown: 720000,
    image: 'https://images.unsplash.com/photo-1600585152915-d208bec867a1?w=1200&h=800&fit=crop',
    backgroundType: 'white',
    note: null,
    productCategory: '5-marla-classic',
    mediaKey: 'villa-5m-classic-2'
  },
  {
    id: 'villa-5m-modern-2',
    name: 'Modern Villa 5M',
    type: 'Modern Home',
    title: '5 Marla Modern Home',
    description: 'Sleek modern design with smart home features and premium amenities.',
    startingPrice: 680000,
    priceAsShown: 750000,
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop',
    backgroundType: 'scenic',
    note: null,
    productCategory: '5-marla-modern',
    mediaKey: 'villa-5m-modern-2'
  }
];

export const houseSeries = {
  allElectric: ['Eco Villa iX', 'Eco Villa i4', 'Eco Villa i5', 'Eco Villa i7'],
  villas: ['Villa X1', 'Villa X2', 'Villa X3', 'Villa X5', 'Villa X6', 'Villa X7', 'Villa XM'],
  residences: ['Residence 2', 'Residence 3', 'Residence 4', 'Residence 5', 'Residence 7', 'Residence 8', 'Residence Z4'],
  premium: ['Premium M Series']
};

export const configuratorOptions = {
  exteriorOptions: [
    { id: 'classic', name: 'Classic', description: 'Traditional design', price: 0, features: ['Classic exterior trim', 'Traditional windows', 'Standard roof'] },
    { id: 'modern', name: 'Modern', description: 'Contemporary style', price: 15000, features: ['Modern exterior trim', 'Large windows', 'Modern roof design'] },
    { id: 'luxury', name: 'Luxury', description: 'Premium finishes', price: 30000, features: ['Premium exterior trim', 'Premium windows', 'Luxury roof'] }
  ],
  interiorOptions: [
    { id: 'standard', name: 'Standard', description: 'Quality finishes', price: 0, features: ['Standard flooring', 'Basic fixtures', 'Standard lighting'] },
    { id: 'premium', name: 'Premium', description: 'High-end materials', price: 20000, features: ['Premium flooring', 'Premium fixtures', 'Premium lighting'] },
    { id: 'luxury', name: 'Luxury', description: 'Ultra-premium', price: 40000, features: ['Luxury flooring', 'Luxury fixtures', 'Luxury lighting'] }
  ],
  bedroomOptions: [
    { id: '2', name: '2 Bedrooms', price: 0 },
    { id: '3', name: '3 Bedrooms', price: 5000 },
    { id: '4', name: '4 Bedrooms', price: 12000 },
    { id: '5', name: '5 Bedrooms', price: 20000 }
  ],
  washroomOptions: [
    { id: '1', name: '1 Washroom', price: 0 },
    { id: '2', name: '2 Washrooms', price: 3000 },
    { id: '3', name: '3 Washrooms', price: 8000 },
    { id: '4', name: '4 Washrooms', price: 15000 }
  ],
  kitchenOptions: [
    { id: '1', name: '1 Kitchen', price: 0 },
    { id: '2', name: '2 Kitchens', price: 10000 }
  ],
  rooftopOptions: [
    { id: 'standard', name: 'Standard Rooftop', price: 0 },
    { id: 'covered', name: 'Covered Rooftop', price: 15000 },
    { id: 'garden', name: 'Rooftop Garden', price: 25000 }
  ],
  accessories: [
    { id: 'smart-home', name: 'Smart Home System', price: 15000, image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop' },
    { id: 'solar', name: 'Solar Panels', price: 25000, image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?w=400&h=300&fit=crop' },
    { id: 'pool', name: 'Swimming Pool', price: 35000, image: 'https://images.unsplash.com/photo-1576610616656-d3aa5d1f4534?w=400&h=300&fit=crop' },
    { id: 'garden', name: 'Landscaped Garden', price: 12000, image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop' },
    { id: 'security', name: 'Security System', price: 8000, image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop' },
    { id: 'garage', name: 'Double Garage', price: 20000, image: 'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=400&h=300&fit=crop' },
    { id: 'premium-doors', name: 'Premium Doors', price: 8000, image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400&h=300&fit=crop' },
    { id: 'door-locks', name: 'Smart Door Locks', price: 3000, image: 'https://images.unsplash.com/photo-1565216694575-34a58bb3ec6d?w=400&h=300&fit=crop' },
    { id: 'windows', name: 'Premium Windows', price: 12000, image: 'https://images.unsplash.com/photo-1568605117033-a86cb6d96ec5?w=400&h=300&fit=crop' },
    { id: 'flooring', name: 'Premium Flooring', price: 15000, image: 'https://images.unsplash.com/photo-1586075010923-2dd4570fb338?w=400&h=300&fit=crop' },
    { id: 'lighting', name: 'Premium Lighting', price: 6000, image: 'https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=400&h=300&fit=crop' }
  ]
};

const basePreviewImageSets = {
  firstFloorFrontend: [
    { type: 'video', src: firstFloorFrontVideo },
    FirstFloorFront1,
    FirstFloorFront2,
    FirstFloorFront3
  ],
  // Placeholder images for individual first floor rooms
  firstFloorLiving: [
    'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop',
    'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1600&h=1000&fit=crop'
  ],
  firstFloorBed: [
    { type: 'video', src: firstFloorFrontVideo },
    FirstFloorFront1,
    FirstFloorFront2,
    FirstFloorFront3
  ],
  firstFloorBath: [
    'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1600&h=1000&fit=crop',
    'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop'
  ],
  groundFloorInterior: [
    { type: 'video', src: groundFloorInteriorVideo },
    GroundFloorInterior1,
    GroundFloorInterior2,
    GroundFloorInterior3
  ],
  groundFloorMasterBed: [
    { type: 'video', src: groundFloorMasterBedVideo },
    GroundFloorMasterBed1,
    GroundFloorMasterBed2,
    GroundFloorMasterBed3
  ],
  // Placeholder images for other ground floor rooms
  groundFloorMasterBath: [
    'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1600&h=1000&fit=crop'
  ],
  groundFloorLiving: [
    'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop',
    'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1600&h=1000&fit=crop'
  ],
  groundFloorKitchen: [
    'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?w=1600&h=1000&fit=crop',
    'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop'
  ],
  stairs: [
    { type: 'video', src: stairsVideo },
    stairs1,
    stairs2,
    stairs3
  ],
  // Elevation-specific media sets (video first, then images)
  elevationClassic: [
    { type: 'video', src: elevationOption1Video },
    elevationOption1Image1,
    elevationOption1Image2,
    elevationOption1Image3
  ],
  elevationModern: [
    { type: 'video', src: elevationOption2Video },
    elevationOption2Image1,
    elevationOption2Image2,
    elevationOption2Image3
  ],
  elevationUltraModern: [
    // { type: 'video', src: elevationOption3Video },
    elevationOption3Image2,
    elevationOption3Image1
  ]
};

// const marla10MediaSet = {
//   firstFloorFrontend: [
//     { type: 'video', src: firstFloorFrontVideo },
//     FirstFloorFront1,
//     FirstFloorFront2,
//     FirstFloorFront3
//   ],
//   // Placeholder images for individual first floor rooms
//   firstFloorLiving: [
//     'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop',
//     'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1600&h=1000&fit=crop'
//   ],
//   firstFloorBed: [
//     { type: 'video', src: firstFloorFrontVideo },
//     FirstFloorFront1,
//     FirstFloorFront2,
//     FirstFloorFront3
//   ],
//   firstFloorBath: [
//     'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1600&h=1000&fit=crop',
//     'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop'
//   ],
//   groundFloorInterior: [
//     { type: 'video', src: groundFloorInteriorVideo },
//     GroundFloorInterior1,
//     GroundFloorInterior2,
//     GroundFloorInterior3
//   ],
//   groundFloorMasterBed: [
//     { type: 'video', src: groundFloorMasterBedVideo },
//     GroundFloorMasterBed1,
//     GroundFloorMasterBed2,
//     GroundFloorMasterBed3
//   ],
//   // Placeholder images for other ground floor rooms
//   groundFloorMasterBath: [
//     'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1600&h=1000&fit=crop'
//   ],
//   groundFloorLiving: [
//     'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop',
//     'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1600&h=1000&fit=crop'
//   ],
//   groundFloorKitchen: [
//     'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?w=1600&h=1000&fit=crop',
//     'https://images.unsplash.com/photo-1505691723518-36a5ac3be353?w=1600&h=1000&fit=crop'
//   ],
//   stairs: [
//     { type: 'video', src: stairsVideo },
//     stairs1,
//     stairs2,
//     stairs3
//   ],
//   // Elevation-specific media sets (video first, then images)
//   elevationClassic: [
//     { type: 'video', src: elevationOption1Video },
//     elevationOption1Image1,
//     elevationOption1Image2,
//     elevationOption1Image3
//   ],
//   elevationModern: [
//     { type: 'video', src: elevationOption2Video },
//     elevationOption2Image1,
//     elevationOption2Image2,
//     elevationOption2Image3
//   ],
//   elevationUltraModern: [
//     // { type: 'video', src: elevationOption3Video },
//     elevationOption3Image2,
//     elevationOption3Image1
//   ]
// };

export const houseMediaSets = {
  'eco-villa-ix': basePreviewImageSets,
  'eco-villa-i4': basePreviewImageSets,
  'villa-10m-classic-1': basePreviewImageSets,
  'villa-10m-modern-1': basePreviewImageSets,
  'villa-5m-classic-2': basePreviewImageSets,
  'villa-5m-modern-2': basePreviewImageSets
};

